import script from "./Lasersko.vue?vue&type=script&setup=true&lang=ts"
export * from "./Lasersko.vue?vue&type=script&setup=true&lang=ts"

import "./Lasersko.vue?vue&type=style&index=0&id=1a24a8b2&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a24a8b2"]])

export default __exports__